/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from 'react';
import { TextField, Grid } from '@material-ui/core';

class TableFilterSearch extends PureComponent {
    constructor(props) {
        super(props);
        const { filter, activeFilters } = this.props;

        this.state = { value: activeFilters[filter.fieldName] || '' };
    }

    handeChange = (event) => {
        const { value } = event.target;
        const { filter, onChange } = this.props;
        this.setState({ value }, () => onChange('search', filter.fieldName, value));
    };

    render() {
        const { filter } = this.props;
        const { value } = this.state;

        return (
            <Grid id="yeself-textField" container>
                <TextField
                    fullWidth
                    id={filter.fieldName}
                    placeholder={filter.placeholder}
                    onChange={this.handeChange}
                    value={value}
                    margin="normal"
                    label={filter.label}
                />
            </Grid>
        );
    }
}

export default TableFilterSearch;
